import { extendTheme } from "@chakra-ui/react"

export const theme1 = extendTheme({
  colors: {
    yellow: {
      50: "#FFF7E5",
      100: "#FFE7B8",
      200: "#FFD88A",
      300: "#FFC95C",
      400: "#FFBA2E",
      500: "#FFAA00",
      600: "#CC8800",
      700: "#996600",
      800: "#664400",
      900: "#332200",
    },
    blue: {
      50: "#ECF0F9",
      100: "#C9D5EE",
      200: "#A6BAE3",
      300: "#839FD8",
      400: "#6084CC",
      500: "#3E69C1",
      600: "#31549B",
      700: "#253F74",
      800: "#192A4D",
      900: "#0C1527",
    },
    red: {
      50: "#FBECE9",
      100: "#F5C9C2",
      200: "#EFA79A",
      300: "#E88473",
      400: "#E2614B",
      500: "#DB3F24",
      600: "#AF321D",
      700: "#842615",
      800: "#58190E",
      900: "#2C0D07",
    },
  },
})

export const theme2 = extendTheme({
  colors: {
    yellow: {
      50: "#FFF7E5",
      100: "#FFE7B8",
      200: "#FFD88A",
      300: "#FFC95C",
      400: "#FFBA2E",
      500: "#FFAA00",
      600: "#CC8800",
      700: "#996600",
      800: "#664400",
      900: "#332200",
    },
    blue: {
      50: "#E5F2FF",
      100: "#B8DBFF",
      200: "#8AC3FF",
      300: "#5CACFF",
      400: "#2E95FF",
      500: "#007DFF",
      600: "#0064CC",
      700: "#004B99",
      800: "#003266",
      900: "#001933",
    },
    red: {
      50: "#FBECE9",
      100: "#F5C9C2",
      200: "#EFA79A",
      300: "#E88473",
      400: "#E2614B",
      500: "#DB3F24",
      600: "#AF321D",
      700: "#842615",
      800: "#58190E",
      900: "#2C0D07",
    },
  },
})

export const theme3 = extendTheme({
  // set styles for global elements
  styles: {
    global: {
      h1: {
        display: "block",
        fontSize: "2em",
        marginBlockStart: "0.67em",
        marginBlockEnd: "0.67em",
        marginInlineStart: "0px",
        marginInlineEnd: "0px",
        fontWeight: "bold",
      },
      h2: {
        display: "block",
        fontSize: "1.5em",
        marginBlockStart: "0.83em",
        marginBlockEnd: "0.83em",
        marginInlineStart: "0px",
        marginInlineEnd: "0px",
        fontWeight: "bold",
      },
      h3: {
        display: "block",
        fontSize: "1.17em",
        marginBlockStart: "1em",
        marginBlockEnd: "1em",
        marginInlineStart: "0px",
        marginInlineEnd: "0px",
        fontWeight: "bold",
      },
      h4: {
        display: "block",
        fontSize: "1em",
        marginBlockStart: "1.33em",
        marginBlockEnd: "1.33em",
        marginInlineStart: "0px",
        marginInlineEnd: "0px",
        fontWeight: "bold",
      },
      h5: {
        display: "block",
        fontSize: "0.83em",
        marginBlockStart: "1.67em",
        marginBlockEnd: "1.67em",
        marginInlineStart: "0px",
        marginInlineEnd: "0px",
        fontWeight: "bold",
      },
    },
  },

  colors: {
    yellow: {
      50: "#FFF7E5",
      100: "#FFE7B8",
      200: "#FFD88A",
      300: "#FFC95C",
      400: "#FFBA2E",
      500: "#FFAA00",
      600: "#CC8800",
      700: "#996600",
      800: "#664400",
      900: "#332200",
    },
    blue: {
      50: "#E5F2FF",
      100: "#B8DBFF",
      200: "#8AC3FF",
      300: "#5CACFF",
      400: "#2E95FF",
      500: "#007DFF",
      600: "#0064CC",
      700: "#004B99",
      800: "#003266",
      900: "#001933",
    },
    red: {
      50: "#EAECFA",
      100: "#C5CAF1",
      200: "#A0A7E8",
      300: "#7B85DF",
      400: "#5663D6",
      500: "#3141CE",
      600: "#2834A4",
      700: "#1E277B",
      800: "#141A52",
      900: "#0A0D29",
    },
    purple: {
      50: "#EAECFA",
      100: "#C5CAF1",
      200: "#A0A7E8",
      300: "#7B85DF",
      400: "#5663D6",
      500: "#3141CE",
      600: "#2834A4",
      700: "#1E277B",
      800: "#141A52",
      900: "#0A0D29",
    },
    pink: {
      50: "#F6EEF6",
      100: "#E6D1E6",
      200: "#D6B3D5",
      300: "#C695C5",
      400: "#B677B4",
      500: "#A55AA4",
      600: "#844883",
      700: "#633662",
      800: "#422442",
      900: "#211221",
    },
    gray: {
      50: "#EEF1F6",
      100: "#D0D9E7",
      200: "#B1C0D7",
      300: "#93A8C8",
      400: "#748FB8",
      500: "#5677A9",
      600: "#455F87",
      700: "#344765",
      800: "#222F44",
      900: "#111822",
    },
  },
})

export const theme4 = extendTheme({
  fonts: {
    heading: `'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif`,
    body: `'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif`,
  },
  styles: {
    global: {
      body: {
        bg: "white",
        color: "gray.800",
        lineHeight: 1.7,
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale",
      },
      h1: {
        display: "block",
        fontSize: "2em",
        marginBlockStart: "0.67em",
        marginBlockEnd: "0.67em",
        marginInlineStart: "0px",
        marginInlineEnd: "0px",
        fontWeight: "800",
        letterSpacing: "-0.03em",
      },
      h2: {
        display: "block",
        fontSize: "1.5em",
        marginBlockStart: "0.83em",
        marginBlockEnd: "0.83em",
        marginInlineStart: "0px",
        marginInlineEnd: "0px",
        fontWeight: "700",
        letterSpacing: "-0.025em",
      },
      h3: {
        display: "block",
        fontSize: "1.17em",
        marginBlockStart: "1em",
        marginBlockEnd: "1em",
        marginInlineStart: "0px",
        marginInlineEnd: "0px",
        fontWeight: "600",
        letterSpacing: "-0.015em",
      },
      h4: {
        display: "block",
        fontSize: "1em",
        marginBlockStart: "1.33em",
        marginBlockEnd: "1.33em",
        marginInlineStart: "0px",
        marginInlineEnd: "0px",
        fontWeight: "600",
        letterSpacing: "-0.01em",
      },
      h5: {
        display: "block",
        fontSize: "0.83em",
        marginBlockStart: "1.67em",
        marginBlockEnd: "1.67em",
        marginInlineStart: "0px",
        marginInlineEnd: "0px",
        fontWeight: "600",
      },
    },
  },
  colors: {
    brand: {
      50: "#FAF8FF",
      100: "#F1ECFE",
      200: "#E3D9FD",
      300: "#D4C7FC",
      400: "#C6B5FB",
      500: "#9f7aea",
      600: "#805ad5",
      700: "#6B46C1",
      800: "#553C9A",
      900: "#231F32",
    },
    gray: {
      50: "#F8F9FA",
      100: "#ECEEEF",
      200: "#DEE2E6",
      300: "#CED4DA",
      400: "#ADB5BD",
      500: "#6C757D",
      600: "#495057",
      700: "#343A40",
      800: "#212529",
      900: "#121314",
    },
    red: {
      50: "#FFF5F5",
      100: "#FED7D7",
      200: "#FEB2B2",
      300: "#FC8181",
      400: "#F56565",
      500: "#E53E3E",
      600: "#C53030",
      700: "#9B2C2C",
      800: "#822727",
      900: "#63171B",
    },
    blue: {
      50: "#EBF8FF",
      100: "#BEE3F8",
      200: "#90CDF4",
      300: "#63B3ED",
      400: "#4299E1",
      500: "#3182CE",
      600: "#2B6CB0",
      700: "#2C5282",
      800: "#2A4365",
      900: "#1A365D",
    },
  },
  components: {
    Button: {
      baseStyle: {
        borderRadius: "xl",
        fontWeight: 600,
        transition: "all 0.2s ease",
        _focus: { boxShadow: "outline" },
      },
      variants: {
        ctaSolidDark: {
          bg: "purple.700",
          color: "white",
          _hover: {
            bg: "purple.800",
            transform: "translateY(-1px)",
            boxShadow: "lg",
          },
          _active: { transform: "translateY(0)" },
        },
        ctaSolidLight: {
          bg: "purple.500",
          color: "white",
          _hover: {
            bg: "purple.600",
            transform: "translateY(-1px)",
            boxShadow: "lg",
          },
          _active: { transform: "translateY(0)" },
        },
      },
    },
    Accordion: {
      baseStyle: {
        container: {
          border: "1px solid",
          borderColor: "gray.200",
          borderRadius: "lg",
          mb: 3,
          overflow: "hidden",
          transition: "border-color 0.2s",
          _hover: { borderColor: "purple.200" },
        },
        button: {
          _hover: { bg: "purple.50" },
          px: 6,
          py: 4,
          fontWeight: 600,
          fontSize: "md",
          color: "gray.800",
        },
        panel: {
          px: 6,
          py: 4,
          color: "gray.600",
          lineHeight: 1.7,
        },
      },
    },
  },
})

export default theme4
